<template>
    <div>
        <section class="container mt-3 py-3">
            <h4>Notificaciones</h4>
            <!-- Implementación -->
            <div class="my-2 ms-3 my-4">
                <h5>Uso</h5>
                <p class="text-dark my-0">Para hacer uso de las notificaciones es necesario importar el archivo <span class="fst-italic">ResourceNotificationMixin.js</span> y agregarlo al arreglo <span class="fst-italic">mixins</span>  del componente.</p>
            <!-- CODIGO QUE SE MUESTRA --> 
            <div v-highlight>
    <pre class="language-javascript"><code>import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
export default {
    mixins: [NotificationMixin],
}</code></pre>
            </div>
            </div>
            <!-- Notificación en un evento click -->
            <div class="my-2 ms-3 my-4">
                <h5>Notificación en un evento click</h5>
                <!-- Implementación -->
                <div class="my-2">
                    <vs-button 
                        class="btn-primary mb-2" 
                        @click="openNotification(null, 'success-sh', `<i class='fas fa-check-circle'></i>`, 'Titulo de Notificación', 'Aqui va el contenido de la notificación', '5000')" 
                        >Abrir Notificación
                    </vs-button>
                </div>
                <p class="text-dark my-0">Notificaciones que se abren despues de ejecutar un método click (<small>indicandonle la posición en null, color, icono de fontawesome, titulo y contenido respectivamente</small>).</p>
                <!-- CODIGO QUE SE MUESTRA -->
                <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><vs-button 
    class="btn-primary" 
    @click="openNotification(
        null, 
        'success-sh', 
        null, 
        'Titulo de Notificación', 
        'Aqui va el contenido de la notificación',
        '5000'
    )" 
    >Abrir Notificación
</vs-button>
</script></code></pre>
                </div>
            </div>
            <!-- Notificación emitida en un método JS -->
            <div class="my-2 ms-3 my-4">
                <h5>Notificación emitida en un método JS</h5>
                <p class="text-dark my-0">Notificaciones que se abren mediante un método de JavaScript (<small>Puede ser generado como consecuencia de una llamada a un servicio</small>). en este caso de ejemplo, el trigger lo generamos desde el created.</p>
                <!-- CODIGO QUE SE MUESTRA -->
                <div v-highlight>
    <pre class="language-javascript"><code>import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
export default {
    mixins: [NotificationMixin],
    created: function(){
        this.methodExample();
    },   
    methods:{
        methodExample: function(){
            this.openNotification(
                null, //posición
                'info-sh',      // color
                null,           // el icono se maneja de forma automatica dependiendo del estatus (color)
                'Ejemplo Notificación', // titulo 
                'Aqui va el contenido de la notificación', // contenido
                '5000'      // duracion de la notificacion
            );
        }
    }
}</code></pre>
                </div>
            </div>
            <!-- Colores -->
            <div class="my-2 ms-3 my-4">
                <h5>Colores</h5>
                <!-- <p class="text-dark my-0">Las notificaciones contendran mensajes de un cierto proceso, para cada tipo de notificación existira un color, estos mensajes pueden informar:</p> -->
                <p class="text-dark my-0">Para cada tipo de contenido en las notificaciones se usara un color diferente, los tipos de contenido con sus respectivos colores son los siguientes:</p>
                <p class="text-dark my-0">El segundo parametro de la funcion <u>openNotification</u> da el color a la notificación. </p>
                <ul>
                    <li>Un proceso exitoso <code> success-sh</code></li>
                    <li>Una advertencia <code> warning-sh</code></li>
                    <li>Un Error <code> danger-sh</code></li>
                    <li>Info <code> info-sh</code></li>
                </ul>
                <div class="d-flex flex-wrap my-2">
                    <vs-button 
                        class="btn-success" 
                        @click="openNotification(
                                    null, 
                                    'success-sh', 
                                    null, 
                                    'Información del proceso', 
                                    'El proceso ha concluido con éxito')" 
                        >.success-sh
                    </vs-button>
                    <vs-button 
                        class="btn-secondary" 
                        @click="openNotification(
                                    null, 
                                    'warning-sh', 
                                    null, 
                                    'Información del proceso', 
                                    'El proceso no se puede concluir porque se detectaron unas advertencias')" 
                        >.warning-sh
                    </vs-button>
                    <vs-button 
                        class="btn-primary" 
                        @click="openNotification(
                                    null, 
                                    'danger-sh', 
                                    null, 
                                    'Información del proceso', 
                                    'El proceso no se puede concluir porque se detectaron errores')" 
                        >.danger-sh
                    </vs-button>
                    <vs-button 
                        class="btn-secondary-variant" 
                        @click="openNotification(
                                    null, 
                                    'info-sh', 
                                    null, 
                                    'Información del proceso', 
                                    'El proceso no se puede concluir porque se detectaron errores')" 
                        >.info-sh
                    </vs-button>
                </div>
                <!-- CODIGO QUE SE MUESTRA -->
                <p class="text-dark my-0">Parametros para la implementación de colores en las notificaciones segun su tipo.</p>
                <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><vs-button 
    class="btn-primary-sh" 
    @click="openNotification(
            null, 
            'success-sh', 
            null, 
            'Titulo de notificación', 
            'Contenido de notificación',
            '5000')" 
    >Titulo del boton
</vs-button>
</script></code></pre>
</div>
            </div>
        </section>
    </div>
</template>
<script>
import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
export default {
    name: 'ComponentePlantilla',
    mixins: [NotificationMixin],
    created: function(){
        this.methodExample();
        window.scrollTo(0, 0);
    },   
    methods:{
        methodExample: function(){
            this.openNotification(
                null,       //posición
                'info-sh',  // color
                 null,      // icon
                'Notificación por evento', // titulo 
                'Este es un ejemplo de notificacion por evento.', // contenido
                '5000'
            );
        }
    }
    
}
</script>

<style>


/* .vs-notification {
    border-radius: 6px !important;
  } */
</style>